export const isObject = data => Object.prototype.toString.call(data) === '[object Object]'
export const isArray = data => Object.prototype.toString.call(data) === '[object Array]'
export const isString = data => typeof data === 'string'
export const isNumber = data => typeof data === 'number'
export const isBoolean = data => typeof data === 'boolean'
export const isFunction = data => typeof data === 'function'

// 获取指定长度的随机字符串
export const getRandomString = (length: number, isNum?: boolean): string => {
  let text = '';
  const possibleNumber = '0123456789';
  const possibleAll = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const possible = isNum ? possibleNumber : possibleAll;

  for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
};

export const getSessionId = (): string => `${Date.now()}#${getRandomString(3, true)}`;

export const getTime = () => Math.floor(Date.now() / 1000);

export const isWindow = () => typeof window !== 'undefined' && window;

export const getWindow = (name?: string): any => {
  if (!isWindow()) return null;
  if (name) return window?.[name];

  return window;
};

export const reWriteListener = function () {
  // var pushState = history.pushState;
  // history.pushState = function () {
  //   return pushState.apply(history, arguments);
  // };
  window.history.pushState =  bindHistoryEvent('pushState');
  window.history.replaceState =  bindHistoryEvent('replaceState');
}

const bindHistoryEvent = function(type) {
  const historyEvent = history[type];
  return function(...args) {
      const newEvent = historyEvent.apply(this, args); //执行history函数
     const e: any = new Event(type);  //声明自定义事件
      e.arguments = args;
      window.dispatchEvent(e);  //抛出事件
      return newEvent;  //返回方法，用于重写history的方法
  };
};

export const getTrackedELesByUrl = async (serverUrl, url) => {
  const data = await fetch(
    `${serverUrl}/track?pageType=current&url=${url}`,
    {
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    }
  )
    .then((res) => res.json())
  return data
}

export const getEleByXpath = (xpath: string) => {
  const doc = window.document
  const result = doc.evaluate(xpath, doc, null, XPathResult.ANY_TYPE, null);
  const item = result.iterateNext();
  return item;
}